import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/bonificaciones.css";

import BonificacionesSummary from "../components/BonificacionesSummary";
import BonificacionesFilters from "../components/BonificacionesFilters";
import BonificacionesTable from "../components/BonificacionesTable";
import BonificacionDetailPanel from "../components/BonificacionDetailPanel";
import { usePermissions } from "../../../../utils/permissions";
import BonificacionesHistorica from "../components/BonificacionesHistorica";
import BonificacionesHistoricaDetail from "../components/BonificacionHistoricaDetail";

export default function BonificacionesView({
  loading,
  error,
  resumen,
  filtros,
  setFiltros,
  limpiarFiltros,
  lastUpdated,

  // histórico
  page,
  pageSize,
  totalPages,
  total,
  goToPage,
  bonificacionesPaginadas,

  // selección
  seleccionado,
  seleccionar,

  // acciones
  reload,
  actualizarEstado,
  registrarDescuento,
  eliminarDescuento,
  abonarAMatricula,
  updatingId,

  // pendientes (esto lo agregas desde tu hook real)
  pendientes,
  pendientesLoading,
  pendientesError,
}) {
  const { hasPermission } = usePermissions();
  const canUpdate = hasPermission("bonificaciones.actualizar");

  const [activeTab, setActiveTab] = useState("pendientes");

  // -------- QUICK FILTERS ----------
  const quickFilter = (key) => {
    seleccionar(null);
    if (key === "total") {
      // Ver todas (ir a tab pendientes sin filtro)
      setActiveTab("pendientes");
      setFiltros(prev => ({
        ...prev,
        estado: "all",
      }));
    } else if (key === "pagada") {
      // Las pagadas están en el histórico, limpiar filtros
      setActiveTab("historico");
      limpiarFiltros();
    } else if (key === "anulada") {
      // Las anuladas están en el histórico
      setActiveTab("historico");
      limpiarFiltros();
    } else {
      // Pendientes y no_pagadas están en la tab de por cobrar
      setActiveTab("pendientes");
      setFiltros(prev => ({
        ...prev,
        estado: key,
      }));
    }
  };

  // Limpiar selección al cambiar de tab
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    seleccionar(null);
  };

  const activeQuickFilter =
    filtros?.estado && filtros.estado !== "all"
      ? filtros.estado
      : "total";

  const lastSync = lastUpdated
    ? lastUpdated.toLocaleString()
    : "Sincronizacion inicial";

  return (
    <section className="management-page management-theme-violet">

      {/* HEADER */}
      <div className="management-card management-header mb-4">
        <div className="flex-fill">
          <p className="management-eyebrow mb-1">Financiero / Bonificaciones</p>
          <h4 className="management-title mb-1">Gestión de bonificaciones</h4>
          <p className="text-muted mb-0 d-none d-sm-block">Controla el estado de los bonos por referido.</p>
        </div>

        <div className="d-flex flex-column align-items-end gap-2 flex-shrink-0">
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      {/* RESUMEN + QUICK FILTERS */}
      <BonificacionesSummary
        resumen={resumen}
        onQuickFilter={quickFilter}
        activeKey={activeQuickFilter}
      />

      {/* TABS */}
      <ul className="nav nav-tabs dashboard-tabs pagos-tabs mb-3" style={{ flexWrap: "nowrap", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link text-nowrap ${activeTab === "pendientes" ? "active" : ""}`}
            onClick={() => handleTabChange("pendientes")}
          >
            Por cobrar
          </button>
        </li>

        <li className="nav-item">
          <button
            type="button"
            className={`nav-link text-nowrap ${activeTab === "historico" ? "active" : ""}`}
            onClick={() => handleTabChange("historico")}
          >
            Historial
          </button>
        </li>
      </ul>

      {/* ------------ PENDIENTES ------------ */}
      {activeTab === "pendientes" && (
        <>
          <BonificacionesFilters
            filtros={filtros}
            setFiltros={setFiltros}
            limpiarFiltros={limpiarFiltros}
            opcionesPendientes={true}
          />

          <div className="row g-3">
            <div className="col-12 col-lg-8">
              <BonificacionesTable
                bonificaciones={pendientes}
                loading={pendientesLoading}
                error={pendientesError}
                onSelect={seleccionar}
                seleccionadoId={seleccionado?.id}
              />
            </div>

            <div className="col-12 col-lg-4 d-flex">
              <BonificacionDetailPanel
                bonificacion={seleccionado}
                onClose={() => seleccionar(null)}
                canUpdate={canUpdate}
                onUpdateEstado={actualizarEstado}
                onRegistrarDescuento={registrarDescuento}
                onEliminarDescuento={eliminarDescuento}
                onAbonarAMatricula={abonarAMatricula}
                updatingId={updatingId}
              />
            </div>
          </div>
        </>
      )}

      {/* ------------ HISTÓRICO ------------ */}
      {activeTab === "historico" && (
        <>
          <BonificacionesFilters
            filtros={filtros}
            setFiltros={setFiltros}
            limpiarFiltros={limpiarFiltros}
            mostrarEstado={false}
          />

          <div className="row g-3">
            <div className="col-12 col-lg-8">
              <BonificacionesHistorica
                bonificaciones={bonificacionesPaginadas}
                loading={loading}
                error={error}
                onSelect={seleccionar}
                seleccionadoId={seleccionado?.id}
              />
            </div>

            <div className="col-12 col-lg-4 d-flex">
              <BonificacionesHistoricaDetail
                bonificacion={seleccionado}
                onClose={() => seleccionar(null)}
                canUpdate={canUpdate}
                onUpdateEstado={actualizarEstado}
                updatingId={updatingId}
              />
            </div>
          </div>

          {/* PAGINACION */}
          <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
            <div className="text-muted small">
              Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}-{Math.min(total, page * pageSize)} de {total}
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap">
              <div className="btn-group">
                <button className="btn btn-outline-secondary btn-sm" style={{ minHeight: 36, minWidth: 36 }} onClick={() => goToPage(page - 1)} disabled={page <= 1}>
                  <i className="bi bi-chevron-left" />
                </button>

                <button className="btn btn-outline-secondary btn-sm" style={{ minHeight: 36 }} disabled>
                  {page} / {totalPages}
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm"
                  style={{ minHeight: 36, minWidth: 36 }}
                  onClick={() => goToPage(page + 1)}
                  disabled={page >= totalPages}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </div>

              <button className="btn btn-outline-secondary btn-sm" style={{ minHeight: 36 }} onClick={reload}>
                <i className="bi bi-arrow-repeat me-2" />
                Recargar
              </button>
            </div>
          </div>
        </>
      )}
    </section>
  );
}
